export const Money = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="7" width="26" height="18" rx="1" stroke="currentColor" stroke-width="2"/>
<circle cx="16" cy="16" r="3" stroke="currentColor" stroke-width="2"/>
<path d="M25 18V20C25 20.5523 24.5523 21 24 21H22M25 14.3333V12C25 11.4477 24.5523 11 24 11L22 11M7 18V20C7 20.5523 7.44772 21 8 21H10M7 14V12C7 11.4477 7.44772 11 8 11H10" stroke="currentColor" stroke-width="2"/>
</svg>`;
